/* eslint-disable unicorn/filename-case -- TODO rename later */
export enum SystemFileRevisionSpecifierType {
  Latest = "Latest",
  Locked = "Locked",
}

export enum SystemResourceType {
  Artifact = "Artifact",
  Model = "Model",
  // Backend snapshot-search serializes resource_type as the Python class name.
  // Files (created with API resourceType "file") use the base `Resource` class.
  File = "Resource",
}
